import application from 'application/application';

application

	.config(['$locationProvider', '$animateProvider', '$httpProvider', '$urlRouterProvider', '$qProvider', ($locationProvider, $animateProvider, $httpProvider, $urlRouterProvider, $qProvider) => {

		// Habilita o modo HTML 5 para trabalhar com states.
		$locationProvider.html5Mode(true);

		// Filtra as animações para elemenos com a classe CSS animate.
		$animateProvider.classNameFilter(/animate/);

		// Adiciona o interceptor de requisições global.
		$httpProvider.interceptors.push('httpInterceptor');
		$httpProvider.interceptors.push('HttpRequestTimeoutInterceptor');
		$httpProvider.interceptors.push('preventTemplateCache');

		// Desabilita mensagens de reject no console (cancelamento das request http)
		$qProvider.errorOnUnhandledRejections(false);

		$urlRouterProvider

			.rule(($injector, $location) => {

				let path = $location.path();

				if (path.substr(-1) === '/')

					return path.substr(0, path.length - 1);

			})

			.otherwise(($injector) => {

				$injector

					.get('$state')

					.go('root.default.otherwise', null, {
						location: false
					});

			});

	}]);
